import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BookingStepService } from '../services/booking-step.service';
import { BookingStepEnum } from '../models/booking-step.enum';
import { OrderStateService } from '../../order/services/order-state.service';
import { map } from 'rxjs/operators';

@Injectable()
export class BookingSingleProductsGuard implements CanActivate {

  constructor(
    private bookingStepService: BookingStepService,
    private router: Router,
    private orderStateService: OrderStateService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.bookingStepService.isBookingSingleProductsAvailable) {
      return true;
    }

    if (this.orderStateService.isNeedReloadOrder) {
      return this.bookingStepService.initFromLoadOrder(BookingStepEnum.SelectBookingSingleProducts)
        .pipe(
          map(_ => {
            if (!this.bookingStepService.isBookingSingleProductsAvailable) {
              this.router.navigate(['/booking']);
              return false;
            }
            return true;
          }));
    }

    this.router.navigate(['/booking']);
    return false;
  }
}
